import { rem } from './factorRangePalette';

/**
 * Shared column geometry. The header's axis ruler and every row draw against
 * the same three columns, so they have to come from one definition or the tick
 * numbers drift out of line with the marks below them.
 */
export const FACTOR_RANGE_GRID = `${rem(216)} minmax(0, 1fr) ${rem(88)}`;

/**
 * Track geometry in px. This is a drawing rather than text: the bar, its caps,
 * the reference tick and the dot are positioned relative to each other, so
 * they stay in absolute units instead of scaling independently.
 */
export const TRACK = {
  height: 36,
  barTop: 12,
  barHeight: 6,
  dotSize: 13,
} as const;
